<script>
const models = window.models

import { selection, activeStep } from './lib.js';
var selectOne = /\(SELECT ONE\)$/;

if(!$selection.options) {
	$selection.options = {};

	for(let [heading, options] of Object.entries($selection.chosenFloorplan.options)) {
		let standard = false;
		options.forEach(function(option) {
			if(option.standard) {
				if(selectOne.test(heading)) {
					$selection.options[heading] = option;
				} else {
					if(!$selection.options[heading]) {
						$selection.options[heading] = []
					}

					$selection.options[heading].push(option);
				}
			}
		});
	}
}
</script>
<div class="byo-specs__main">

    <h2 class="byo-heading -interior">Add-on Features</h2>
    <p class="byo-specs__header-text">Choose from the list of additional options for this floorplan. For pricing and additional information, please <a href="https://tiffinmotorhomes.com/dealer-locator" target="_blank">contact a dealer.</a></p>

    <div class="byo-specs__options">
        {#each Object.entries($selection.chosenFloorplan.options) as [heading, options]}
            <div class="byo-specs__group">
                <h4 class="byo-specs__group-heading">{ heading }</h4>
                <ul class="byo-specs__group-list">
                    {#each options as option}
                    <li class="byo-specs__group-list-item">
                        <label class="byo-specs__opt-label">
                            {#if selectOne.test(heading) }
                                <input type="radio" name="{heading}" value={option} bind:group={ $selection.options[heading] } class="byo-specs__opt-checkbox">
                            {:else}
								<input type="checkbox" name="{heading}" value={option} bind:group={ $selection.options[heading] } class="byo-specs__opt-checkbox">
                            {/if}
                            <div class="byo-specs__opt-text">
                                { option.name }
                                    {#if option.tooltip_id}
                                        <span class= "byo-specs__tooltip">
                                            <span class="byo-specs__tooltip-inner">
                                                {#if option.promo_title}
                                                    <h3>{option.promo_title}</h3>
                                                {/if}

                                                {#if option.promo_content}
                                                    <p>{@html option.promo_content}</p>
                                                {/if}

                                                {#if option.byo_promo_btn && option.byo_promo_btn.url && option.byo_promo_btn.title}
                                                    <p>
                                                        <a
                                                            class="button"
                                                            href={option.byo_promo_btn.url}
                                                            target={option.byo_promo_btn.target || '_self'}
                                                        >
                                                            {option.byo_promo_btn.title}
                                                        </a>
                                                    </p>
                                                {/if}
                                            </span>
                                        </span>
                                    {/if}
                                <span class="byo-specs__opt-text-detail">
                                    { option.footnote }
                                </span>

                            </div>
                        </label>
                    </li>
                    {/each}
                </ul>
            </div>
        {/each}
    </div>
</div>


<div class="continue-bar js-continue-bar -active">
    <button class="continue-bar__text button -back js-forward" on:click="{() => { $activeStep = 3; window.scrollTo(0,0);}}">Prev</button>
    <button disabled={!$selection.chosenFloorplan} class="continue-bar__text button -forward js-forward" on:click="{() => { $activeStep = 5; window.scrollTo(0,0);}}">Next</button>
</div>

<style>
.byo-specs__main {
    margin-top: 0 !important;
    max-width: 815px !important;
}
.byo-specs__header-text {
    font-size: 1.4rem !important;
    text-align: center;
}

.byo-specs__group-heading {
    font-size: 1.4rem !important;
    letter-spacing: .3rem;
    line-height: 1em;
    margin-bottom: 2.4rem;
    text-transform: uppercase;
}

.byo-specs__opt-checkbox {
    height: 16px;
    vertical-align: top;
    width: 16px;
}

.byo-specs__opt-text {
    font-size: 18px;
}

.byo-specs__group-list-item {
    margin-bottom: 1.1rem;
    font-weight: bold;
}

.byo-specs__opt-text-detail {
    display: block;
    font-style: italic;
    font-weight: 400;
}
.byo-specs__tooltip-inner .button {
    padding: 8px 20px;
}

</style>

